// @flow


import {getAllIds} from './getAllIds';
import type {TreeStructure} from '../typedef';


const mapChildrenToParent = (children: TreeStructure, parentIds) => {
    return children.reduce((result, child) => {
        if (child.children) {
            return {
                [child.id]: parentIds,
                ...mapChildrenToParent(child.children, [...parentIds, child.id])
            };
        }
        return {
            ...result,
            [child.id]: parentIds
        };
    }, {});
};
export const getCheckedIds = (data: TreeStructure, exclude: Array<string> = []): Array<string> => {
    const allIds = getAllIds(data);

    const mappedChildrenToParent = data.reduce((result, item) => {
        if (item.children) {
            return {...result, ...mapChildrenToParent(item.children, [item.id])};
        }

        return result;
    }, {});

    const excludedParents = Object.keys(mappedChildrenToParent).reduce((result, key) => {
        if (exclude.includes(key)) {
            return result.concat(mappedChildrenToParent[key]);
        }

        return result;
    }, []).concat(exclude);

    return allIds.filter(item => !excludedParents.includes(item));
};

